import React, { useMemo } from 'react';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

interface Props {
  path: string;
  mimeType?: string;
  filename?: string;
  fallbackLabel: string;
  onZoom?: (path: string) => void;
  onRemove?: () => void;
}

const isPdf = (path: string, mimeType?: string) =>
  mimeType === 'application/pdf' || path.toLowerCase().endsWith('.pdf');

const ReceiptFileThumbnail: React.FC<Props> = ({ path, mimeType, filename, fallbackLabel, onZoom, onRemove }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div style={styles.container}>
      {isPdf(path, mimeType) ? (
        <a href={path} target="_blank" rel="noopener noreferrer" style={styles.pdfLink}>
          <PictureAsPdfIcon style={styles.pdfIcon} />
          <span style={styles.pdfLabel}>{filename ?? 'PDF'}</span>
        </a>
      ) : (
        <img
          src={path}
          alt={filename ?? fallbackLabel}
          onClick={onZoom ? () => onZoom(path) : undefined}
          title={onZoom ? 'クリックで拡大' : undefined}
          style={onZoom ? { ...styles.image, cursor: 'zoom-in' } : styles.image}
        />
      )}
      <span style={styles.filename}>{filename ?? fallbackLabel}</span>
      {onRemove && (
        <a onClick={onRemove} style={styles.removeLink}>
          削除
        </a>
      )}
    </div>
  );
};

const getStyles = () => ({
  container: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    gap: 4,
    flexShrink: 0,
    width: 100
  },
  pdfLink: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    width: 80,
    height: 80,
    border: '1px solid #ddd',
    borderRadius: 4,
    background: '#fff5f5',
    textDecoration: 'none' as const
  },
  pdfIcon: {
    fontSize: 36,
    color: '#d32f2f'
  },
  pdfLabel: {
    fontSize: 10,
    color: '#d32f2f',
    maxWidth: 72,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis' as const,
    whiteSpace: 'nowrap' as const
  },
  image: {
    width: 80,
    height: 80,
    objectFit: 'contain' as const,
    border: '1px solid #ddd',
    borderRadius: 4
  },
  filename: {
    fontSize: 10,
    color: '#888',
    maxWidth: 100,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis' as const,
    whiteSpace: 'nowrap' as const
  },
  removeLink: {
    fontSize: 11,
    color: '#c72f62',
    cursor: 'pointer' as const
  }
});

export default ReceiptFileThumbnail;
